"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssuesBcfApi = void 0;
var _endpointHelpers = require("../util/endpointHelpers");
var _queryClientUtils = require("../util/queryClientUtils");
const IssuesBcfApi = exports.IssuesBcfApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    // create bcf
    create(payload) {
      return api.create("issues/bcf/export", payload);
    }
  };
}, {
  // no queries to invalidate (only mutation)
  invalidateByQueryKeys: () => _queryClientUtils.NO_QUERIES_TO_INVALIDATE
});
//# sourceMappingURL=IssuesBcfApi.js.map